export function removePaymentWidgets() {
  const container = document.querySelector('#paymentWidgetContainer')
  container?.querySelectorAll('iframe').forEach((iframe) => iframe.remove())
}
